import validator from "validator";

export const urlValidate = (url: string) => validator.isURL(url);